module.exports = Date.now || now

function now() {
    return new Date().getTime()
}



/*****************
 ** WEBPACK FOOTER
 ** /Users/ryan/src/trib/ballot.bak.real/~/date-now/index.js
 ** module id = 18
 ** module chunks = 1
 **/